export default __webpack_public_path__ + "static/cafeterabg1_3-2b67cccff79787f2d4f2cf49a64907f3.png";